module.exports = __webpack_public_path__ + "62704bcd2bffe05d101e9ef88c7b80c9.png";